import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-all-transaction',
  templateUrl: './all-transaction.component.html',
  styleUrl: './all-transaction.component.scss'
})
export class AllTransactionComponent {

  myTranscationImageUrl = environment.ImageBaseUrl;
  transactions: any[] = [];
  errorMessage: string = '';
  loading: boolean = true;

  constructor(private api:ApiServiceService ,private Loader:LoaderService) {}

  ngOnInit(): void {
    this.fetchTransactions();
  }

  fetchTransactions(): void {
    this.Loader.showLoader();
    this.api.allOrderTransaction().subscribe(
      (response : any) => {
        this.Loader.hideLoader();
        this.transactions = response.data; // Bind response data to the component
        this.loading = false;
      },
      (error : any) => {
        this.Loader.hideLoader();
        this.errorMessage = error.error.message || 'Failed to fetch transactions';
        this.loading = false;
      }
    );
  }

}
